var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getDocumentEvents } from '@workalizer/db/queries/analytic/driveAnalytic';
import { AnalyticPeriodsEnum, DriveEventActionEnum } from '@workalizer/shared';
import { getInterval, getPeriodInTimeZone, getSqlGroupBy, groupBy, groupByPeriod, groupDriveAnalyticByPeriod } from '@workalizer/shared/utils';
import { format, formatISO, startOfHour } from 'date-fns';
var documentUpdateActions = [
    DriveEventActionEnum.DOCUMENT_EDIT,
    DriveEventActionEnum.DOCUMENT_RENAME,
    DriveEventActionEnum.DOCUMENT_CHANGE_ACCESS,
    DriveEventActionEnum.DOCUMENT_RESTORE
];
function processDriveAnalyticHourly(documentEvents, dateFrom, dateTo) {
    var totalDocsCreated = 0;
    var totalDocsUpdated = 0;
    var countsByHourIso = new Map();
    for (var _i = 0, documentEvents_1 = documentEvents; _i < documentEvents_1.length; _i++) {
        var event = documentEvents_1[_i];
        var isCreate = event.action === DriveEventActionEnum.DOCUMENT_CREATE;
        var isUpdate = documentUpdateActions.includes(event.action);
        if (isCreate)
            totalDocsCreated += 1;
        if (isUpdate)
            totalDocsUpdated += 1;
        var hourIso = formatISO(startOfHour(event.date));
        if (!countsByHourIso.has(hourIso)) {
            countsByHourIso.set(hourIso, { created: 0, updated: 0 });
        }
        var hourRow = countsByHourIso.get(hourIso);
        if (isCreate)
            hourRow.created += 1;
        if (isUpdate)
            hourRow.updated += 1;
    }
    var mappedData = Array.from(countsByHourIso.entries()).map(function (_a) {
        var iso = _a[0], counts = _a[1];
        return ({
            date: iso,
            items: [{ created: counts.created, updated: counts.updated }]
        });
    });
    var grouped = groupByPeriod(mappedData, dateFrom, dateTo, AnalyticPeriodsEnum.HOUR);
    var analytics = grouped.map(function (item) { return ({
        date: item.date,
        docsCreated: item.items.reduce(function (sum, row) { return sum + row.created; }, 0),
        docsUpdated: item.items.reduce(function (sum, row) { return sum + row.updated; }, 0)
    }); });
    return {
        totalDocsCreated: totalDocsCreated,
        totalDocsUpdated: totalDocsUpdated,
        analytics: analytics
    };
}
export var processDriveAnalyticCalculation = function (documentEvents, dateFrom, dateTo, interval) {
    if (interval === AnalyticPeriodsEnum.HOUR) {
        return processDriveAnalyticHourly(documentEvents, dateFrom, dateTo);
    }
    var totalDocsCreated = documentEvents.filter(function (event) { return event.action === DriveEventActionEnum.DOCUMENT_CREATE; }).length;
    var totalDocsUpdated = documentEvents.filter(function (event) {
        return documentUpdateActions.includes(event.action);
    }).length;
    var eventsWithFormattedDate = documentEvents.map(function (event) { return (__assign(__assign({}, event), { date: format(event.date, 'yyyy-MM-dd') })); });
    var groupedByCalendarDay = groupBy(eventsWithFormattedDate, 'date');
    var analytics = Object.entries(groupedByCalendarDay).map(function (_a) {
        var date = _a[0], events = _a[1];
        return ({
            date: date,
            docsCreated: events.filter(function (event) { return event.action === DriveEventActionEnum.DOCUMENT_CREATE; }).length,
            docsUpdated: events.filter(function (event) {
                return documentUpdateActions.includes(event.action);
            }).length
        });
    });
    var analyticsGrouped = groupDriveAnalyticByPeriod(analytics, dateFrom, dateTo);
    return {
        totalDocsCreated: totalDocsCreated,
        totalDocsUpdated: totalDocsUpdated,
        analytics: analyticsGrouped
    };
};
export var processDriveAnalytic = function (workspaceId, userIds, dateFromFilter, dateToFilter, timeZone) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, dateFrom, dateTo, dateFromStartOfDay, dateToEndOfDay, interval, sqlGroupBy, documentEvents;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getPeriodInTimeZone(dateFromFilter, dateToFilter, timeZone), dateFrom = _a.dateFrom, dateTo = _a.dateTo, dateFromStartOfDay = _a.dateFromStartOfDay, dateToEndOfDay = _a.dateToEndOfDay;
                interval = getInterval(dateFromStartOfDay, dateToEndOfDay);
                sqlGroupBy = getSqlGroupBy(interval);
                return [4 /*yield*/, getDocumentEvents(workspaceId, userIds, new Date(dateFrom), new Date(dateTo), timeZone, { sqlGroupBy: sqlGroupBy })];
            case 1:
                documentEvents = _b.sent();
                return [2 /*return*/, processDriveAnalyticCalculation(documentEvents, dateFromStartOfDay, dateToEndOfDay, interval)];
        }
    });
}); };
